
import { useState } from 'react';

export default function ContactForm({titulo, frase}){
    const [formData, setFormData] = useState({
        nombre: '',
        apellido: '',
        ciudad: '',
        detalle: ''
    });
    const [errors, setErrors] = useState({});
    const [isSubmitting, setIsSubmitting] = useState(false);

    function validateField(name, value) {
        if (!value || value.trim() === '') {
            return 'Este campo es requerido';
        }
        if (name === 'nombre' || name === 'apellido') {
            if (value.length < 2) {
                return 'Debe tener al menos 2 caracteres';
            }
        }
        return '';
    }

    function handleInputChange(e) {
        const { name, value } = e.target;
        setFormData(prev => ({ ...prev, [name]: value }));
        
        // Validar en tiempo real
        const error = validateField(name, value);
        setErrors(prev => ({ ...prev, [name]: error }));
    }

    function handleSubmit(e) {
        e.preventDefault();
        setIsSubmitting(true);

        // Validar todos los campos
        const newErrors = {};
        Object.keys(formData).forEach(key => {
            const error = validateField(key, formData[key]);
            if (error) newErrors[key] = error;
        });

        if (Object.keys(newErrors).length > 0) {
            setErrors(newErrors);
            setIsSubmitting(false);
            return;
        }

        // Simular delay de envío
        setTimeout(() => {
            window.open(
                `https://api.whatsapp.com/send?phone=522283667786&text=${encodeURIComponent(
                    `Hola, soy ${formData.nombre} ${formData.apellido} de ${formData.ciudad} y ${formData.detalle}.`
                )}`,
                '_blank'
            );
            setIsSubmitting(false);
        }, 800);
    }

    const inputStyle = {
        width: '100%',
        padding: '1rem 1.2rem 1rem 3rem',
        border: '2px solid #e8f0fe',
        borderRadius: '12px',
        marginTop: '0.5rem',
        fontFamily: 'Montserrat, sans-serif',
        fontWeight: '500',
        background: '#fefefe',
        fontSize: '1.05rem',
        color: '#2c3e50',
        outline: 'none',
        transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
        boxShadow: '0 2px 12px rgba(8, 57, 95, 0.06)',
    };

    const inputFocusStyle = {
        borderColor: '#00921E',
        boxShadow: '0 4px 20px rgba(0, 146, 30, 0.15), 0 0 0 3px rgba(0, 146, 30, 0.1)',
        transform: 'translateY(-1px)',
    };



    return(
        <div>
            {/*Formulario de contacto moderno y elegante*/}
            <section
                style={{
                    background: 'linear-gradient(135deg, #f8fbff 0%, #e8f4f8 50%, #e0f2e9 100%)',
                    padding: 'clamp(3rem, 8vw, 5rem) 1rem',
                    fontFamily: 'Montserrat, sans-serif',
                    minHeight: 'auto',
                    position: 'relative',
                    overflow: 'hidden',
                }}
            >
                {/* Elementos decorativos de fondo */}
                <div style={{ 
                    position: 'absolute', 
                    top: '10%', 
                    left: '-5%', 
                    width: '200px', 
                    height: '200px', 
                    background: 'radial-gradient(circle, rgba(0, 146, 30, 0.08) 0%, transparent 70%)', 
                    borderRadius: '50%',
                    animation: 'float 6s ease-in-out infinite'
                }} />
                <div style={{ 
                    position: 'absolute', 
                    bottom: '15%', 
                    right: '-3%', 
                    width: '150px', 
                    height: '150px', 
                    background: 'radial-gradient(circle, rgba(8, 57, 95, 0.06) 0%, transparent 70%)', 
                    borderRadius: '50%',
                    animation: 'float 8s ease-in-out infinite reverse'
                }} />

                <div style={{ 
                    maxWidth: '580px', 
                    margin: '0 auto', 
                    borderRadius: '24px', 
                    boxShadow: '0 20px 60px rgba(8, 57, 95, 0.12), 0 8px 25px rgba(0, 0, 0, 0.06)', 
                    background: 'rgba(255, 255, 255, 0.95)', 
                    padding: 'clamp(2rem, 5vw, 3rem)', 
                    position: 'relative', 
                    backdropFilter: 'blur(10px)',
                    border: '1px solid rgba(255, 255, 255, 0.3)'
                }}>
                    
                    {/* Header del formulario */}
                    <div style={{ textAlign: 'center', marginBottom: '2.5rem' }}>
                        <div style={{ 
                            display: 'inline-flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            width: '60px',
                            height: '60px',
                            background: 'linear-gradient(135deg, #00921E, #0ba127)',
                            borderRadius: '50%',
                            marginBottom: '1.5rem',
                            boxShadow: '0 8px 25px rgba(0, 146, 30, 0.25)'
                        }}>
                            <svg width="28" height="28" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M20 4H4C2.9 4 2.01 4.9 2.01 6L2 18C2 19.1 2.9 20 4 20H20C21.1 20 22 19.1 22 18V6C22 4.9 21.1 4 20 4ZM20 8L12 13L4 8V6L12 11L20 6V8Z" fill="white"/>
                            </svg>
                        </div>
                        
                        <h2 style={{ 
                            fontWeight: '700', 
                            fontSize: 'clamp(1.8rem, 4vw, 2.3rem)', 
                            marginBottom: '1rem', 
                            color: '#2c3e50', 
                            letterSpacing: '-0.5px',
                            lineHeight: '1.2',
                            fontFamily: 'Montserrat, sans-serif' 
                        }}>
                            {titulo}
                        </h2>
                        <p style={{
                            color: '#00921E',
                            fontFamily: 'Montserrat, sans-serif',
                            fontSize: 'clamp(1.05rem, 2.5vw, 1.2rem)',
                            fontWeight: '500',
                            lineHeight: '1.5',
                            maxWidth: '480px',
                            margin: '0 auto',
                        }}>{frase}</p>
                    </div>

                    <form onSubmit={handleSubmit}>
                        <div style={{
                            display: 'grid',
                            gridTemplateColumns: 'repeat(auto-fit, minmax(220px, 1fr))',
                            gap: '1.5rem',
                            marginBottom: '1.5rem',
                        }}>
                            {/* Campo Nombre */}
                            <div style={{ position: 'relative' }}>
                                <label 
                                    htmlFor="nombre-input"
                                    style={{
                                        display: 'block',
                                        fontWeight: '600',
                                        fontSize: '0.95rem',
                                        color: '#34495e',
                                        marginBottom: '0.3rem',
                                        fontFamily: 'Montserrat, sans-serif',
                                        letterSpacing: '0.5px',
                                    }}
                                >
                                    <svg style={{ display: 'inline-block', marginRight: '8px', verticalAlign: 'middle' }} width="16" height="16" viewBox="0 0 24 24" fill="none" aria-hidden="true">
                                        <path d="M12 12C14.21 12 16 10.21 16 8C16 5.79 14.21 4 12 4C9.79 4 8 5.79 8 8C8 10.21 9.79 12 12 12ZM12 14C9.33 14 4 15.34 4 18V20H20V18C20 15.34 14.67 14 12 14Z" fill="#00921E"/>
                                    </svg>
                                    Nombre
                                </label>
                                <div style={{ position: 'relative' }}>
                                    <svg style={{ 
                                        position: 'absolute', 
                                        left: '12px', 
                                        top: '50%', 
                                        transform: 'translateY(-50%)', 
                                        zIndex: 1,
                                        opacity: 0.6
                                    }} width="20" height="20" viewBox="0 0 24 24" fill="none" aria-hidden="true">
                                        <path d="M12 12C14.21 12 16 10.21 16 8C16 5.79 14.21 4 12 4C9.79 4 8 5.79 8 8C8 10.21 9.79 12 12 12Z" fill="#00921E"/>
                                    </svg>
                                    <input
                                        id="nombre-input"
                                        type="text"
                                        placeholder="Tu nombre"
                                        style={{
                                            ...inputStyle,
                                            borderColor: errors.nombre ? '#e74c3c' : '#e8f0fe',
                                        }}
                                        name="nombre"
                                        value={formData.nombre}
                                        onChange={handleInputChange}
                                        onFocus={(e) => Object.assign(e.target.style, inputFocusStyle)}
                                        onBlur={(e) => Object.assign(e.target.style, inputStyle)}
                                        aria-required="true"
                                        aria-invalid={errors.nombre ? 'true' : 'false'}
                                        aria-describedby={errors.nombre ? 'nombre-error' : undefined}
                                    />
                                </div>
                                {errors.nombre && (
                                    <span 
                                        id="nombre-error"
                                        role="alert"
                                        style={{ color: '#e74c3c', fontSize: '0.85rem', marginTop: '0.3rem', display: 'block' }}
                                    >
                                        {errors.nombre}
                                    </span>
                                )}
                            </div>

                            {/* Campo Apellido */}
                            <div style={{ position: 'relative' }}>
                                <label 
                                    htmlFor="apellido-input"
                                    style={{
                                        display: 'block',
                                        fontWeight: '600',
                                        fontSize: '0.95rem',
                                        color: '#34495e',
                                        marginBottom: '0.3rem',
                                        fontFamily: 'Montserrat, sans-serif',
                                        letterSpacing: '0.5px',
                                    }}
                                >
                                    <svg style={{ display: 'inline-block', marginRight: '8px', verticalAlign: 'middle' }} width="16" height="16" viewBox="0 0 24 24" fill="none" aria-hidden="true">
                                        <path d="M12 12C14.21 12 16 10.21 16 8C16 5.79 14.21 4 12 4C9.79 4 8 5.79 8 8C8 10.21 9.79 12 12 12ZM12 14C9.33 14 4 15.34 4 18V20H20V18C20 15.34 14.67 14 12 14Z" fill="#00921E"/>
                                    </svg>
                                    Apellido
                                </label>
                                <div style={{ position: 'relative' }}>
                                    <svg style={{ 
                                        position: 'absolute', 
                                        left: '12px', 
                                        top: '50%', 
                                        transform: 'translateY(-50%)', 
                                        zIndex: 1,
                                        opacity: 0.6
                                    }} width="20" height="20" viewBox="0 0 24 24" fill="none" aria-hidden="true">
                                        <path d="M12 12C14.21 12 16 10.21 16 8C16 5.79 14.21 4 12 4C9.79 4 8 5.79 8 8C8 10.21 9.79 12 12 12Z" fill="#00921E"/>
                                    </svg>
                                    <input
                                        id="apellido-input"
                                        type="text"
                                        placeholder="Tu apellido"
                                        style={{
                                            ...inputStyle,
                                            borderColor: errors.apellido ? '#e74c3c' : '#e8f0fe',
                                        }}
                                        name="apellido"
                                        value={formData.apellido}
                                        onChange={handleInputChange}
                                        onFocus={(e) => Object.assign(e.target.style, inputFocusStyle)}
                                        onBlur={(e) => Object.assign(e.target.style, inputStyle)}
                                        aria-required="true"
                                        aria-invalid={errors.apellido ? 'true' : 'false'}
                                        aria-describedby={errors.apellido ? 'apellido-error' : undefined}
                                    />
                                </div>
                                {errors.apellido && (
                                    <span 
                                        id="apellido-error"
                                        role="alert"
                                        style={{ color: '#e74c3c', fontSize: '0.85rem', marginTop: '0.3rem', display: 'block' }}
                                    >
                                        {errors.apellido}
                                    </span>
                                )}
                            </div>
                        </div>

                        {/* Campo Ciudad */}
                        <div style={{ position: 'relative', marginBottom: '1.5rem' }}>
                            <label 
                                htmlFor="ciudad-input"
                                style={{
                                    display: 'block',
                                    fontWeight: '600',
                                    fontSize: '0.95rem',
                                    color: '#34495e',
                                    marginBottom: '0.3rem',
                                    fontFamily: 'Montserrat, sans-serif',
                                    letterSpacing: '0.5px',
                                }}
                            >
                                <svg style={{ display: 'inline-block', marginRight: '8px', verticalAlign: 'middle' }} width="16" height="16" viewBox="0 0 24 24" fill="none" aria-hidden="true">
                                    <path d="M12 2C8.13 2 5 5.13 5 9C5 14.25 12 22 12 22S19 14.25 19 9C19 5.13 15.87 2 12 2ZM12 11.5C10.62 11.5 9.5 10.38 9.5 9S10.62 6.5 12 6.5S14.5 7.62 14.5 9S13.38 11.5 12 11.5Z" fill="#00921E"/>
                                </svg>
                                Ciudad
                            </label>
                            <div style={{ position: 'relative' }}>
                                <svg style={{ 
                                    position: 'absolute', 
                                    left: '12px', 
                                    top: '50%', 
                                    transform: 'translateY(-50%)', 
                                    zIndex: 1,
                                    opacity: 0.6
                                }} width="20" height="20" viewBox="0 0 24 24" fill="none" aria-hidden="true">
                                    <path d="M12 2C8.13 2 5 5.13 5 9C5 14.25 12 22 12 22S19 14.25 19 9C19 5.13 15.87 2 12 2ZM12 11.5C10.62 11.5 9.5 10.38 9.5 9S10.62 6.5 12 6.5S14.5 7.62 14.5 9S13.38 11.5 12 11.5Z" fill="#00921E"/>
                                </svg>
                                <input
                                    id="ciudad-input"
                                    type="text"
                                    placeholder="¿De qué ciudad nos escribes?"
                                    style={{
                                        ...inputStyle,
                                        borderColor: errors.ciudad ? '#e74c3c' : '#e8f0fe',
                                    }}
                                    name="ciudad"
                                    value={formData.ciudad}
                                    onChange={handleInputChange}
                                    onFocus={(e) => Object.assign(e.target.style, inputFocusStyle)}
                                    onBlur={(e) => Object.assign(e.target.style, inputStyle)}
                                    aria-required="true"
                                    aria-invalid={errors.ciudad ? 'true' : 'false'}
                                    aria-describedby={errors.ciudad ? 'ciudad-error' : undefined}
                                />
                            </div>
                            {errors.ciudad && (
                                <span 
                                    id="ciudad-error"
                                    role="alert"
                                    style={{ color: '#e74c3c', fontSize: '0.85rem', marginTop: '0.3rem', display: 'block' }}
                                >
                                    {errors.ciudad}
                                </span>
                            )}
                        </div>

                        {/* Campo Servicio */}
                        <div style={{ position: 'relative', marginBottom: '2rem' }}>
                            <label 
                                htmlFor="servicio-select"
                                style={{
                                    display: 'block',
                                    fontWeight: '600',
                                    fontSize: '0.95rem',
                                    color: '#34495e',
                                    marginBottom: '0.3rem',
                                    fontFamily: 'Montserrat, sans-serif',
                                    letterSpacing: '0.5px',
                                }}
                            >
                                <svg style={{ display: 'inline-block', marginRight: '8px', verticalAlign: 'middle' }} width="16" height="16" viewBox="0 0 24 24" fill="none" aria-hidden="true">
                                    <path d="M19 3H5C3.9 3 3 3.9 3 5V19C3 20.1 3.9 21 5 21H19C20.1 21 21 20.1 21 19V5C21 3.9 20.1 3 19 3ZM5 19V5H19V19H5ZM17 12L12 7L7 12H10V16H14V12H17Z" fill="#00921E"/>
                                </svg>
                                Servicio de Interés
                            </label>
                            <div style={{ position: 'relative' }}>
                                <svg style={{ 
                                    position: 'absolute', 
                                    left: '12px', 
                                    top: '50%', 
                                    transform: 'translateY(-50%)', 
                                    zIndex: 1,
                                    opacity: 0.6
                                }} width="20" height="20" viewBox="0 0 24 24" fill="none" aria-hidden="true">
                                    <path d="M7 10L12 15L17 10H7Z" fill="#00921E"/>
                                </svg>
                                <select
                                    id="servicio-select"
                                    style={{
                                        ...inputStyle,
                                        cursor: 'pointer',
                                        borderColor: errors.detalle ? '#e74c3c' : '#e8f0fe',
                                        appearance: 'none',
                                        backgroundImage: 'none',
                                    }}
                                    name="detalle"
                                    value={formData.detalle}
                                    onChange={handleInputChange}
                                    onFocus={(e) => Object.assign(e.target.style, inputFocusStyle)}
                                    onBlur={(e) => Object.assign(e.target.style, inputStyle)}
                                    aria-required="true"
                                    aria-invalid={errors.detalle ? 'true' : 'false'}
                                    aria-describedby={errors.detalle ? 'detalle-error' : undefined}
                                >
                                    <option value="">¿En qué podemos ayudarte?</option>
                                    <option value="quiero más información sobre las propiedades en venta">🏠 Propiedades en Venta</option>
                                    <option value="quiero más información sobre las propiedades en renta">🏘️ Propiedades en Renta</option>
                                    <option value="quiero más información sobre la administración de propiedades">🏢 Administración de Propiedades</option>
                                    <option value="quiero más información sobre las propiedades en remate bancario">⚖️ Remates Bancarios</option>
                                    <option value="quiero más información sobre los servicios de mantenimiento">🔧 Servicios de Mantenimiento</option>
                                    <option value="quiero más información sobre los servicios de construcción">🏗️ Servicios de Construcción</option>
                                </select>
                            </div>
                            {errors.detalle && (
                                <span 
                                    id="detalle-error"
                                    role="alert"
                                    style={{ color: '#e74c3c', fontSize: '0.85rem', marginTop: '0.3rem', display: 'block' }}
                                >
                                    {errors.detalle}
                                </span>
                            )}
                        </div>

                        {/* Botón de envío */}
                        <div style={{ textAlign: 'center' }}>
                            <button
                                type="submit"
                                disabled={isSubmitting}
                                aria-label={isSubmitting ? "Enviando mensaje..." : "Enviar mensaje por WhatsApp"}
                                style={{
                                    background: isSubmitting 
                                        ? 'linear-gradient(135deg, #bdc3c7, #95a5a6)' 
                                        : 'linear-gradient(135deg, #00921E 0%, #0ba127 50%, #08395F 100%)',
                                    color: 'white',
                                    padding: '1.2rem 3rem',
                                    borderRadius: '50px',
                                    border: 'none',
                                    cursor: isSubmitting ? 'not-allowed' : 'pointer',
                                    display: 'inline-flex',
                                    alignItems: 'center',
                                    gap: '0.8rem',
                                    fontWeight: '700',
                                    fontSize: '1.1rem',
                                    letterSpacing: '0.5px',
                                    boxShadow: isSubmitting 
                                        ? '0 4px 15px rgba(0, 0, 0, 0.1)' 
                                        : '0 8px 30px rgba(0, 146, 30, 0.3), 0 4px 15px rgba(0, 0, 0, 0.1)',
                                    transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
                                    transform: isSubmitting ? 'scale(0.98)' : 'scale(1)',
                                    fontFamily: 'Montserrat, sans-serif',
                                    position: 'relative',
                                    overflow: 'hidden',
                                    minHeight: '44px',
                                    minWidth: '44px',
                                }}
                                onMouseEnter={(e) => {
                                    if (!isSubmitting) {
                                        e.target.style.transform = 'scale(1.05) translateY(-2px)';
                                        e.target.style.boxShadow = '0 12px 40px rgba(0, 146, 30, 0.4), 0 8px 25px rgba(0, 0, 0, 0.15)';
                                    }
                                }}
                                onMouseLeave={(e) => {
                                    if (!isSubmitting) {
                                        e.target.style.transform = 'scale(1) translateY(0)';
                                        e.target.style.boxShadow = '0 8px 30px rgba(0, 146, 30, 0.3), 0 4px 15px rgba(0, 0, 0, 0.1)';
                                    }
                                }}
                            >
                                {isSubmitting ? (
                                    <>
                                        <div style={{
                                            width: '20px',
                                            height: '20px',
                                            border: '2px solid transparent',
                                            borderTop: '2px solid white',
                                            borderRadius: '50%',
                                            animation: 'spin 1s linear infinite'
                                        }} />
                                        Enviando...
                                    </>
                                ) : (
                                    <>
                                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" aria-hidden="true">
                                            <path d="M2 21L23 12L2 3V10L17 12L2 14V21Z" fill="white"/>
                                            <path d="M2 21L23 12L2 3V10L17 12L2 14V21Z" stroke="white" strokeWidth="1" strokeLinejoin="round"/>
                                        </svg>
                                        Enviar por WhatsApp
                                    </>
                                )}
                            </button>
                        </div>
                    </form>
                </div>

                {/* CSS Animations */}
                <style>
                    {`
                        @keyframes float {
                            0%, 100% { transform: translateY(0px) rotate(0deg); }
                            33% { transform: translateY(-10px) rotate(1deg); }
                            66% { transform: translateY(5px) rotate(-1deg); }
                        }
                        @keyframes spin {
                            0% { transform: rotate(0deg); }
                            100% { transform: rotate(360deg); }
                        }
                    `}
                </style>
            </section>
        </div>
    );
}